import { index, integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';
import { syncedColumns } from './common';

/** Synced. Spending categories; optional on every entry. */
export const categories = sqliteTable(
  'categories',
  {
    ...syncedColumns(),
    /** Stable key for built-in categories ('food', 'cigarettes', 'loan_payment'); null for user-made. */
    key: text('key'),
    name: text('name').notNull(),
    icon: text('icon'),
    hidden: integer('hidden', { mode: 'boolean' }).notNull().default(false),
    /** Display order, ascending (Spending → Categories reorder). */
    position: real('position').notNull().default(0),
  },
  (t) => [index('categories_user_key_idx').on(t.userId, t.key)],
);
